import { array } from '@ember/helper';
import { t } from 'ember-intl';
import { BreadcrumbsItem } from 'core/components';

<template>
  {{! Need to add the breadcrumb item here otherwise it wouldn't be picked up by breadcrumb container. Project is defined as a query param project_id and not as a route }}
  {{#if @controller.model.project.id}}
    <BreadcrumbsItem
      @icon="file-text"
      @route="cloud.orgs.detail.projects.list"
      @models={{array @controller.model.organization.id}}
      @text={{t "components.page.projects.list.title-short"}}
    />
  {{/if}}

  <BreadcrumbsItem
    @icon="file-text"
    @route="cloud.orgs.detail.projects.detail"
    @models={{array
      @controller.model.organization.id
      @controller.model.project.id
    }}
    @text={{@controller.model.project.name}}
  />

  {{outlet}}
</template>
